import React from 'react';
import { Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import AppTooltip from './tooltip';

interface ICommonFormLabel {
  controlId: any;
  label: any;
  isRequired?: any;
  tooltip?: any;
  tooltipContent?: any;
}

const CommonFormLabel: React.FC<ICommonFormLabel> = ({
  controlId,
  label,
  isRequired,
  tooltip,
  tooltipContent,
}) => {
  return (
    <Form.Label htmlFor={controlId} className={`mb-1 small d-inline-flex lh-sm gap-1`}>
      <span>
        {label}
        {isRequired && <span className="text-danger">*</span>}
      </span>
      {tooltip && (
        <AppTooltip title={tooltip}>
          <Button
            type="button"
            variant="link"
            className="p-0 border-0 lh-sm link-dark d-inline-flex align-items-center"
          >
            {tooltipContent}
          </Button>
        </AppTooltip>
      )}
    </Form.Label>
  );
};

export default CommonFormLabel;